import { create } from 'zustand';

type State = {
  showSecondaryMenu: boolean;
  activeMenuItemId: string | number;
  userHasAssessmentRole: boolean;
};

type Action = {
  setShowSecondaryMenu: (showSecondaryMenu: boolean) => void;
  setActiveMenuItemId: (activeMenuItemId: string | number) => void;
  setUserHasAssessmentRole: (userHasAssessmentRole: boolean) => void;
};

export const useGlobalMenuStore = create<State & Action>((set) => ({
  activeMenuItemId: '',
  showSecondaryMenu: false,
  userHasAssessmentRole: false,
  setShowSecondaryMenu: (showSecondaryMenu: boolean) =>
    set(() => ({ showSecondaryMenu })),
  setActiveMenuItemId: (activeMenuItemId: string | number) =>
    set(() => ({ activeMenuItemId })),
  setUserHasAssessmentRole: (userHasAssessmentRole: boolean) =>
    set(() => ({ userHasAssessmentRole })),
}));
